import { usePublisherStore } from "~/store/PublisherModule";
import { isPublicRoute } from "~/common/publicRoutes";

type RequestMethods = "GET" | "POST" | "PUT" | "DELETE";

interface IRequestOptions {
  method?: RequestMethods;
  body?: any;
  params?: Record<string, any>;
  query?: string;
  // Обычно тип авторизации выводится из маршрута. Ручки, которым нужен явный
  // тип (например админские роуты блога — asAdmin), передают его сюда.
  authType?: "asAdmin" | "asPublisher" | "asAdvertiser";
}

// Start of Selection
export const simpleApi = async (endpoint: string, options: IRequestOptions = {}) => {
  // Получаем информацию о текущем маршруте и откуда пришли
  const route = useRoute();
  const adv = !route.fullPath.includes('publisher');

  // Получаем referrer из браузера (откуда пришли)
  if (process.client) {
    // Определяем модуль по маршруту
    const currentModule = getCurrentModule(route.name as string);
  }

  // Функция для определения модуля по имени маршрута
  function getCurrentModule(routeName: string): string {
    if (!routeName) return 'unknown';

    if (routeName.includes('publisher')) return 'publisher';
    if (routeName.includes('moderation')) return 'moderation';
    if (routeName.includes('order')) return 'order';
    if (routeName.includes('catalog')) return 'catalog';
    if (routeName.includes('ch-') || routeName.includes('channel')) return 'channel';
    if (routeName.includes('login')) return 'auth';
    if (routeName === 'index' || routeName === 'main') return 'main';

    return 'other';
  }
  const query = options.query || ""; // Получаем строку запроса или устанавливаем пустую строку, если она не задана
  try {
    const config = useRuntimeConfig(); // Получаем конфигурацию среды выполнения
    const store = usePublisherStore(); // Получаем доступ к хранилищу Publisher

    const apiPublisherUrl = config.public.LIGHT_API_ORIGIN; // URL API из конфигурации

    // Получаем токен из куки или из хранилища, если куки не определены
    const token =
      useCookie("authorizedP").value && useCookie("authorizedP").value !== "undefined"
        ? useCookie("authorizedP").value
        : localStorage.getItem("usePublisherStore__authorized")
          ? localStorage.getItem("usePublisherStore__authorized")
          : store.authorized;


    // стало
    const isFormData = typeof FormData !== 'undefined' && options.body instanceof FormData;
    let headers: Record<string, string> = {}
    if (options.authType) {
      headers["Auth-Type"] = options.authType;
    } else if (adv && route.fullPath.includes('settings')) {
      headers["Auth-Type"] =  "asAdvertiser";
    } else {
      headers["Auth-Type"] =  "asPublisher";
    }
    
    if (token) headers.Authorization = `Bearer ${token}`;
    if (!isFormData) headers["Content-Type"] = "application/json";

    // Выполняем запрос с использованием $fetch
    const response = await $fetch(`${apiPublisherUrl}${endpoint}${query}`, {
      method: options.method || "GET", // Устанавливаем метод запроса, по умолчанию GET
      body: options.body, // Передаем тело запроса, если оно есть
      headers, // Передаем заголовки
      params: options.params, // Передаем параметры запроса, если они есть
    });
    return response; // Возвращаем ответ
  } catch (error: any) {
    // Проверяем, есть ли оригинальный ответ сервера
    const serverError = error.data || error.response?.data || error;

    if (serverError.code === 1513) {
      return { error: serverError };
    }

    if (serverError.code === 2800) {
      return { error: error.statusCode };
    }

    if (serverError.code === 2808) {
      return null;
    }

    if (serverError.code === 2404) {
      const msg = serverError.message || '';
      let channelType = 'канала';
      if (msg.includes('vk.com') || msg.includes('vk.ru')) {
        channelType = 'VK-сообщества';
      } else if (msg.includes('max.ru')) {
        channelType = 'MAX-канала';
      } else if (msg.includes('t.me') || msg.includes('telegram')) {
        channelType = 'телеграм-канала';
      }
      throw new Error(`Адрес ${channelType} занят`);
    }

    if (error.statusCode === 401) {
      const currentModule = getCurrentModule(route.name as string);
      // Публичные страницы читают те же ручки, но входа не требуют. Если
      // отвечать на их 401 разлогином, посетителя с протухшим токеном
      // выбрасывает из блога или каталога в кабинет — а он туда не собирался.
      if (currentModule !== 'channel' && !isPublicRoute(route.name as string)) {
        useCookie("lookingFor").value = route.fullPath;
        usePublisherStore().logout();
        useCookie("authorizedP").value = "";
        navigateTo("/publisher");
        return null;
      }
    }

    // Логируем полный объект ошибки
    console.error("Full error details:", {
      status: error.statusCode,
      message: serverError.message,
      code: serverError.code,
      debug: serverError.debug,
      timestamp: serverError.timestamp,
    });

    // Обрабатываем ошибку и выбрасываем новое исключение с сообщением об ошибке.
    // Код и тело ответа прокидываем на самом Error — иначе они теряются, и вызывающий
    // код не может отличить одну ошибку бэка от другой (см. common/API/apiErrors.ts).
    const throwable: any = new Error(serverError.message || `Query error for ${endpoint}`);
    throwable.code = serverError.code;
    throwable.data = serverError;
    throw throwable;
  }
};
